<div class="logo">
  @if (showBack) {
    <button
      class="logo__backButton"
      type="button"
      (click)="buttonClick($event)"
      >
      <mat-icon class="logo__backButton--icon">arrow_back</mat-icon>
    </button>
  }
  <img
    class="logo__image"
    src="{{logoToShow}}"
    alt=""
    (error)="$any($event.target).src = defaultLogo"
    />
</div>
